<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
// // import 'echarts-liquidfill';

export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left2Data: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      // console.log(props)
      chart.init(props.left2Data, props.name, props.color);
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init() {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);
    let splitColor = "#728AE4";
    this.state.chart.setOption({
      // backgroundColor: "#0A1222",
      tooltip: {
        show: false, // 弹层数据去掉
      },
      legend: {
        show: false,
      },
      radar: {
        center: ["50%", "50%"], // 外圆的位置
        radius: "65%",
        name: {
          textStyle: {
            color: "#fff",
            fontSize: 14,
          },
        },
        // TODO:
        indicator: [
          {
            name: "气候条件",
            max: 100,
          },
          {
            name: "土壤条件",
            max: 100,
          },
          {
            name: "生物学特性",
            max: 100,
          },
          {
            name: "历史发生记录",
            max: 100,
          },
          {
            name: "防治措施效果",
            max: 100,
          },
        ],
        splitArea: {
          // 坐标轴在 grid 区域中的分隔区域，默认不显示。
          show: true,
          areaStyle: {
            // 分隔区域的样式设置。
            color: ["#131C34"], // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
          },
        },
        axisLine: {
          // 指向外圈文本的分隔线样式
          lineStyle: {
            color: splitColor,
          },
        },
        splitLine: {
          lineStyle: {
            type: "solid",
            color: splitColor, // 分隔线颜色
            width: 1, // 分隔线线宽
          },
        },
      },
      series: [
        {
          type: "radar",
          symbolSize: 0,
          itemStyle: {
            borderColor: "rgba(66, 242, 185, 1)",
            color: "#fff",
            borderWidth: 0.2,
          },
          lineStyle: {
            normal: {
              width: 4,
              color: "#2E71F9",
            },
          },
          data: [
            {
              // TODO:
              value: [80, 80, 80, 70, 60, 50],
              name: "男",
              areaStyle: {
                normal: {
                  color: "#1A2F5D",
                },
              },
            },
            {
              // TODO:
              value: [40, 70, 50, 60, 30, 80],
              name: "女",
              itemStyle: {
                borderColor: "rgba(245, 196, 85, 1)",
                color: "#fff",
                borderWidth: 0.2,
              },
              lineStyle: {
                normal: {
                  width: 4,
                  color: "#35DA83",
                },
              },
              areaStyle: {
                normal: {
                  color: "#27525D",
                },
              },
            },
          ],
        },
      ],
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
